// import { useState } from 'react';
// import VoxPlayer from './components/VoxPlayer';
// import LoginPage from './components/LoginPage';

// function App() {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [userData, setUserData] = useState(null);

//   const handleLogin = (credentials) => {
//     // Store user data and authenticate
//     setUserData(credentials);
//     setIsAuthenticated(true);
//   };

//   return (
//     <>
//       {!isAuthenticated ? (
//         <LoginPage onLogin={handleLogin} />
//       ) : (
//         <VoxPlayer userData={userData} />
//       )}
//     </>
//   );
// }

// export default App;




import { useState, useEffect } from 'react';
import VoxPlayer from './components/VoxPlayer';
import LoginPage from './components/LoginPage';


function App() {
  const params = new URLSearchParams(window.location.search);
  const uid = params.get("uid");

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userData, setUserData] = useState(null);

  // Check login state on mount
  useEffect(() => {
    const token = localStorage.getItem('User_biostartechnology');
    const storedUser = localStorage.getItem('User_biostar_userdata');
    if (token) {
      setIsAuthenticated(true);
      if (storedUser) {
        try {
          setUserData(JSON.parse(storedUser));
        } catch {
          setUserData(null);
        }
      }
    }
  }, []);

  const handleLogin = (credentials) => {
    // attach uid if exists
    const userObj = {
      ...credentials,
      embedUid: uid
    };
    setUserData(userObj);
    setIsAuthenticated(true);
    // Persist user data for refresh
    localStorage.setItem('User_biostar_userdata', JSON.stringify(userObj));
  };

  return (
    <>
      {!isAuthenticated ? (
        <LoginPage onLogin={handleLogin} />
      ) : (
        <VoxPlayer userData={userData} />
      )}
    </>
  );
}

export default App;
